import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RequirePhone = () => {
  const { userData, loading } = useAuth();

  if (loading) return null;

  // 관리자 생성 계정(loginId)은 전화번호 인증 불요
  if (!userData?.phoneE164 && !userData?.loginId) {
    return <Navigate to="/link-phone" replace />;
  }

  return <Outlet />;
};

export default RequirePhone;
